// Conditionally run code for local environments
export const isDevelopment = () => {
    return process && process.env && (process.env.NODE_ENV === 'development');
};

// Convert nodeList to Array
export const listToArray = function(node_list) {
    return Array.prototype.slice.call(node_list);
};

// Send an XMLHttpRequest
export const sendXHR = function(xhr_parameters, method) {
    var xhr = new XMLHttpRequest();
    var request_url = xhr_parameters['request_url'];
    var request_extras = xhr_parameters['request_extras'];
    var request_success = xhr_parameters['request_success'];
    var request_failure = xhr_parameters['request_failure'];
    var is_form_data = false;

    // Check for custom methods
    switch(method) {
        case 'FORM_POST':
            is_form_data = true;
            method = 'POST';
            break;
    }

    // Handle timeouts in modern browsers
    xhr.ontimeout = function () {
        console.log("FAIL - HTTP request for '" + request_url + "' timed out.");
    };

    // Handle aborted connections
    xhr.onabort = function () {
        console.log("FAIL - HTTP request for '" + request_url + "' was aborted.");
    };

    // Handle when XHR has processed
    xhr.onreadystatechange = function() {
        if (this.readyState === 4) {
            switch(this.status) {
                case 200:
                case 201:
                case 204:
                    request_success(this.responseText, request_extras);
                    break;
                default:
                    request_failure(this);
                    break;
            }
        }
    };

    // Start the XHR process
    xhr.open(method, request_url, true);
    xhr.timeout = 120000;
    xhr.withCredentials = true;

    // Add extra headers for Form POST
    if(is_form_data) {        
        //xhr.setRequestHeader('Accept', 'application/json, text/plain, */*');
       // xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    }

    // Configure timeout for XHR
    // Set as 0 for Production
    // Simulate a real-world environment with random timeouts for Development
    var timeout = 0;

    if(isDevelopment()) {
        timeout = Math.ceil(Math.random() * 2000);
    }

    //console.log('send XHR');
    //console.log(timeout)

    setTimeout(function(){
        switch(method) {
            case 'GET':
                xhr.send();
                break;
            case 'POST':
                // This is the request payload
                xhr.send(request_extras);
                break;
        }
    }, timeout);
};

// Default failure for XHR call
export const failedRequest = function() {
    console.log('The request failed.');
};

// Debounce function for 
// Example use: debouncer(functionToRun, 200)
export const debouncer = function(func, wait, immediate){
    var timeout;

    return function executedFunction() {
        var context = this;
        var args = arguments;
            
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };

        var callNow = immediate && !timeout;
        
        clearTimeout(timeout);

        timeout = setTimeout(later, wait);
        
        if (callNow) func.apply(context, args);
    };
};

// Find the anchor element from a click event
export const findLink = function(event) {
    var target = event['target'];
    var tag_type = target['tagName'].toLowerCase();
    var found_link = false;

    if(tag_type === 'a'){
        found_link = true;
    }

    // Cater for clicking on child elements of the anchor
    while(!found_link){
        target = target['parentNode'];
        tag_type = target['tagName'].toLowerCase();

        if(tag_type === 'a') {
            found_link = true;
        }
    }

    return target;
};

// Check for current viewport
export const getViewport = function() {
    var viewport_element = document.querySelector('body');
    var element_styles = window.getComputedStyle(viewport_element, null);
    var viewport = parseInt(element_styles['zIndex']);
    
    return viewport;
};

// Check for variable type
export const getVarType = function(object) {
    // Arrays
    if (Array.isArray(object)){
        return "array";
    }

    // String
    if (typeof(object) === "string"){
        return "string";
    }
    
    // Boolean
    if (typeof(object) === "boolean"){
        return "boolean";
    }

    // Undefined
    if (typeof(object) === "undefined"){
        return "undefined";
    }
    
    // Object
    return "object";
};

// Covert HTML string to dangerous HTML React object
export const dangerousHTML = (html_string) => {
    return {
        '__html': html_string
    };
};

// ruturns a link for users to return to the report. Builds it from the user data
export const returnEmailLink = ($userData) => {
    //currentAssetID == current
    //availableNavItems == b
    //questionResponses == c

    let data = $userData;
    let currentAsset = data.currentAssetID;
    let navItems = data.availableNavItems;
    let expandedItem = data.expandedItem;
    let responses = data.questionResponses;
    let uuid = data.uniqueUserID;

    //get the initial Email
    let url = window.location.href.split('?')[0];
    //set this as we do diffent things if we know they have returned via this link
    url += '?return=email';
    // add the unique user id
    url += '&uuid=' + uuid;
    //add the expanded asset
    url += '&ei=' + expandedItem;
    // add the current Asset
    url += '&current=' + currentAsset;

    // add the available progression nav asset ids
    let b = navItems.join(',');
    url += '&b=' + b;

    // make a array of objects of the question asset ids and the users response to the question
    let keys = Object.keys(responses).map((item) => {
        return item + '_' + responses[item];
    });

    let c = keys.join(',');
    url += '&c=' + c;
    //console.log(url);
    return url;
}


//sends the user data url to Matrix
export const sendUserData = ($globalText,$userData,$successCallback,$failCallback) => {
    //if(controlData.hasSubmittedContent === false){
        let formURL = $globalText.submitContentURL;
        let data = returnEmailLink($userData);
        //console.log('sending user data');

        let assetID = Number($globalText.submitContentAssetID) + 1;
        let pageName = 'SQ_FORM_' + assetID + '_PAGE';
        let refName = 'form_email_' + assetID + '_referral_url'
        let qName = 'q' + assetID + ':q1';
        let submitName = 'form_email_' + assetID + '_submit';

        let formData = new FormData();
        formData.append(pageName,1);
        formData.append(refName,'https://www.business.qld.gov.au/_admin/');            
        formData.append(qName,data);
        formData.append(submitName,'Submit');
        let xhr_parameters = {
            'request_url': formURL,
            'request_success': $successCallback,
            'request_failure': $failCallback,
            'request_extras': formData
        };

        sendXHR(xhr_parameters ,'FORM_POST');

   // }
}